export default __webpack_public_path__ + "static/bgContact-4324337aa475dfe823313d3749490372.png";